<template>
  <div class="pop_cv pop_bege popup_wrap" style="display:block">
    <div class="popup_in">
      <div class="popup">
        <div class="popup_close stay_close close-animate">
          <a href="javascript:void(0);" @click.prevent="closePop();">
            <CLOSE />
          </a>
        </div>
        <div class="pop_frame">
          <div class="cv_send_img">
            <img :src="img + '/layout/cv_send.png'" />
          </div>
          <h2 class="title25">
            <span>שליחת קו”ח למשרת</span>
            {{name}}
          </h2>
          <div class="pop_cv_form form_before" v-html="form"></div>
          <div
            class="results_form form_thank"
            style="display:none"
          >פרטיך נשלחו בהצלחה! אנו ניצור איתך קשר.</div>
        </div>
      </div>
    </div>
    <!-- <div class="bgblack"></div> -->
  </div>
</template>

<script>
import CLOSE from "../../assets/img/close.svg";
export default {
  props: ["name"],
  data() {
    return {
      form: wpData.cv_from,
      img: wpData.assets_url
    };
  },
  mounted() {
    wpcf7.initForm(jQuery(".wpcf7-form"));
    let $name = this.name;
    $('input[name=your-job]').val($name);
    setTimeout(() => {

      $(".wpcf7-form .submit_bt").on("click", function(e) {
        $(".wpcf7-form .submit_bt").addClass("proccessing");
      });
      $(".wpcf7").on("wpcf7invalid", function(e) {
        $(".wpcf7-form .submit_bt").removeClass("proccessing");
      });
      $(".wpcf7").on("wpcf7submit", function(e) {
        $(".wpcf7-form .submit_bt").removeClass("proccessing");
      });
      var inputs = document.querySelectorAll(".inputfile");
      Array.prototype.forEach.call(inputs, function(input) {
        var inp = $(input);
        var label = inp.closest(".form_file").find("label"),
          labelVal = label.innerHTML;

        input.addEventListener("change", function(e) {
          var fileName = "";
          if (this.files && this.files.length > 1)
            fileName = (
              this.getAttribute("data-multiple-caption") || ""
            ).replace("{count}", this.files.length);
          else fileName = e.target.value.split("\\").pop();

          if (fileName) label.find(".my-file").html(fileName);
          else label.html(flabelVal);
        });
      });
      document.addEventListener("wpcf7mailsent", function(event) {
        if (event.detail.apiResponse.status == "mail_sent") {

          var $form = document.querySelector(".form_before");
          var $thank = document.querySelector(".form_thank");
          $form.setAttribute("style", "display: none");
          $thank.setAttribute("style", "display:block");
          var submit = document.querySelector(".submit_bt");
          submit.classList.remove("proccessing");
          $(".submit_bt").removeClass("proccessing");
        }
      });
    }, 1000);
  },
  methods: {
    closePop() {
      this.$modal.hide("cvform");
    }
  },
  components: {
    CLOSE
  }
};
</script>

<style scoped>
.results_form {
  max-width: 600px !important;
}
</style>